import { Component, ViewChild } from '@angular/core';
import {Platform, Nav, ToastController} from 'ionic-angular';

import { RcsInstallServiceProvider } from '../providers/rcs-setup-service/rcs-install-service';
import { RcsStartupServiceProvider } from '../providers/rcs-setup-service/rcs-startup-service';
import {interval} from "rxjs/observable/interval";
import {RcsSyncDataProvider} from "../providers/rcs-sync-data-service/rcs-sync-data-service";
import {RcsConnectorIndexDbProvider} from "../providers/rcs-connector-index-db/rcs-connector-index-db";

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav_controller: Nav;
  rootPage:any = 'page-login';

  constructor(platform: Platform,
    private install_service: RcsInstallServiceProvider,
    private startup_service: RcsStartupServiceProvider,
    sync_jobs_service: RcsSyncDataProvider,
    db_service: RcsConnectorIndexDbProvider,
    toast_controller: ToastController,
    ) {
    platform.ready().then(async () => {
      this.install_service.install_setup();
      await new Promise(res => setTimeout(res, 2000));
      this.startup_service.start_app_processes();
      this.start_auto_job_sync(sync_jobs_service, db_service, toast_controller);
    });
  }

  public openPage(page:string){
    this.nav_controller.setPages([{'page': page, 'params': {}}]);
  }

  private start_auto_job_sync(sync_jobs_service, db_service, toast_controller){
    console.log("In Start Auto Job Sync");
    if (!localStorage.getItem('job_sync')){
      const date = new Date()
      date.setHours(21)
      date.setMinutes(15)
      date.setDate(date.getDate() - 1)
      localStorage.setItem('job_sync', date.toUTCString());
    }
    this.sync_jobs(sync_jobs_service, db_service, toast_controller);
    interval(1800000).subscribe(
      time =>{ this.sync_jobs(sync_jobs_service, db_service, toast_controller); })
  }

  private sync_jobs(sync_jobs_service, db_service, toast_controller) {
    if (new Date() > new Date(localStorage.getItem('job_sync'))){
      if (localStorage.getItem('online_status') == 'true'){
        db_service.search_by_key('login', 'user_login').subscribe(login => {
          if (login !== undefined) {
            sync_jobs_service.sync_jobs(login).subscribe(() => {
              console.log("synced jobs");
              this.nav_controller.setRoot('HomePage');

              let date = new Date()
              if ((date.getHours() == 21 && date.getMinutes() <= 15) || date.getHours() >= 21) {
                date.setDate(date.getDate() + 1);
              }
              date.setHours(21)
              date.setMinutes(15)
              localStorage.setItem('job_sync', date.toUTCString());
              localStorage.removeItem('manual_sync_needed');
            })
          }
        })
      }else{
        localStorage.setItem('manual_sync_needed', '1');
        toast_controller.create({
          message: "Bitte die Jobs manuell synchronisieren",
          showCloseButton: true,
          closeButtonText: "OK"
        }).present();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts